import React from 'react';
import { BringzzText, BringzzIcon } from "@bringzz/components";
import { useTranslation } from 'react-i18next';
import { useNavigation } from "context/NavigationContext";

const ScanCTA = () => {
    const { t } = useTranslation();
    const { navigate } = useNavigation();
    
    const handleClick = () => {
        navigate('/scan');
    };
    
    return (
        <div className='mt-2 mx-2 flex space-x-4 p-4 items-center rounded-xl bg-lemon-yellow cursor-pointer' onClick={handleClick}>
            <BringzzIcon size="16" icon="IconScan" folder="LineIcons" />
            <BringzzText tag='h4'>{t('component.search.scan.title')}</BringzzText>
        </div>
    );
};

export default ScanCTA;